/**
 * Returns true if `name` (case-insensitive, trimmed) already exists in `items`,
 * excluding the item with `excludeId` (used when editing an existing item).
 */
export function isDuplicate(
  name: string,
  items: { id: string; name: string }[],
  excludeId?: string,
): boolean {
  const lower = name.trim().toLowerCase();
  return items.some(item => item.name.toLowerCase() === lower && item.id !== excludeId);
}